import { statusTagIntlIds } from './status-tag.ids';

export const statusTagLangEnUs = {
  [statusTagIntlIds.active]: 'Active',
  [statusTagIntlIds.inactive]: 'Inactive',
};
